import { FC } from 'react';

import Chip from '@mui/material/Chip';

import css from './TournamentProvidersColumn.module.css';

import { TournamentModel } from 'v2/types/TournamentModel';

interface TournamentProvidersColumnProps {
  tournament: TournamentModel;
}

export const TournamentProvidersColumn: FC<TournamentProvidersColumnProps> = ({ tournament }) => (
  <div className={css.tournamentProvidersColumn}>
    {tournament.providerNames.map((p) => (
      <Chip key={p} label={p} color="secondary" size="small" />
    ))}
  </div>
);
